export default "__VITE_ASSET__bee69f0c__"